var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _c("cancel-modal", {
        attrs: {
          "modal-id": "my-subscription-cancel-modal",
          visible: _vm.showCancelModal,
          title: _vm.$t("subscription.cancel_confirm_title"),
          message: _vm.$t("subscription.cancel_confirm_text"),
          "justification-label": _vm.$t("subscription.cancellation_reason"),
          "justification-placeholder": _vm.$t(
            "subscription.cancel_reason_placeholder"
          ),
          "ok-title": _vm.$t("action.confirm"),
          "cancel-title": _vm.$t("action.cancel"),
        },
        on: {
          confirm: _vm.doCancel,
          cancel: function ($event) {
            _vm.showCancelModal = false
          },
          "update:visible": function ($event) {
            _vm.showCancelModal = $event
          },
        },
      }),
      _c("Grid", {
        ref: "grid",
        attrs: {
          service: _vm.service,
          route_name: "my_subscriptions",
          route_grid_path: "/grid",
          order_column: "id",
          hide_edit: true,
          hide_delete: true,
        },
        scopedSlots: _vm._u([
          {
            key: "gridThead",
            fn: function () {
              return [
                _c("vs-th", { key: "id", attrs: { "sort-key": "id" } }, [
                  _vm._v(_vm._s(_vm.$t("subscription.id"))),
                ]),
                _c(
                  "vs-th",
                  {
                    key: "plan",
                    attrs: { "sort-key": "subscription_plan_id" },
                  },
                  [_vm._v(_vm._s(_vm.$t("subscription.plan")))]
                ),
                _c(
                  "vs-th",
                  { key: "status", attrs: { "sort-key": "status" } },
                  [_vm._v(_vm._s(_vm.$t("subscription.status")))]
                ),
                _c("vs-th", { key: "latest_invoice" }, [
                  _vm._v(_vm._s(_vm.$t("subscription.latest_invoice"))),
                ]),
                _c("vs-th", { key: "last_paid" }, [
                  _vm._v(_vm._s(_vm.$t("subscription.last_paid_invoice"))),
                ]),
                _c(
                  "vs-th",
                  { key: "started_at", attrs: { "sort-key": "started_at" } },
                  [_vm._v(_vm._s(_vm.$t("subscription.started_at")))]
                ),
                _c(
                  "vs-th",
                  { key: "ends_at", attrs: { "sort-key": "ends_at" } },
                  [_vm._v(_vm._s(_vm.$t("subscription.ends_at")))]
                ),
              ]
            },
            proxy: true,
          },
          {
            key: "gridData",
            fn: function (props) {
              return _vm._l(props.data, function (tr, indextr) {
                return _c(
                  "vs-tr",
                  { key: indextr, attrs: { data: tr } },
                  [
                    _c("vs-td", { key: "id", attrs: { width: "5%" } }, [
                      _c("div", [_vm._v(" " + _vm._s(tr.id) + " ")]),
                    ]),
                    _c("vs-td", { key: "plan", attrs: { width: "22%" } }, [
                      _c("div", [
                        _vm._v(
                          " " +
                            _vm._s(
                              tr.subscription_plan
                                ? tr.subscription_plan.name
                                : "-"
                            )
                        ),
                      ]),
                    ]),
                    _c(
                      "vs-td",
                      { key: "status", attrs: { width: "12%" } },
                      [
                        _c(
                          "vs-chip",
                          {
                            staticClass: "text-base",
                            attrs: {
                              transparent: "",
                              color: _vm.getStatusColor(tr.status),
                            },
                          },
                          [_vm._v(_vm._s(tr.status_label))]
                        ),
                      ],
                      1
                    ),
                    _c(
                      "vs-td",
                      { key: "latest_invoice", attrs: { width: "14%" } },
                      [
                        _c("div", { staticClass: "text-sm" }, [
                          _vm._v(_vm._s(tr.latest_invoice_status_label || "—")),
                        ]),
                      ]
                    ),
                    _c("vs-td", { key: "last_paid", attrs: { width: "14%" } }, [
                      _c("div", { staticClass: "text-sm" }, [
                        _vm._v(_vm._s(tr.last_paid_invoice_display || "—")),
                      ]),
                    ]),
                    _c(
                      "vs-td",
                      { key: "started_at", attrs: { width: "10%" } },
                      [
                        _c("div", [
                          _vm._v(
                            " " + _vm._s(_vm.formatDate(tr.started_at)) + " "
                          ),
                        ]),
                      ]
                    ),
                    _c("vs-td", { key: "ends_at", attrs: { width: "10%" } }, [
                      _c("div", [
                        _vm._v(" " + _vm._s(_vm.formatDate(tr.ends_at)) + " "),
                      ]),
                    ]),
                    _c("vs-td", { attrs: { width: "13%" } }, [
                      _c(
                        "div",
                        { staticClass: "flex flex-row gap-2 items-center" },
                        [
                          _c("feather-icon", {
                            directives: [
                              {
                                name: "permission",
                                rawName: "v-permission",
                                value: "my_subscriptions.show",
                                expression: "'my_subscriptions.show'",
                              },
                              {
                                name: "tooltip",
                                rawName: "v-tooltip.top",
                                value: {
                                  content: _vm.$t("action.consult"),
                                  delay: { show: 100, hide: 100 },
                                },
                                expression:
                                  "{\n                content: $t('action.consult'),\n                delay: { show: 100, hide: 100 }\n              }",
                                modifiers: { top: true },
                              },
                            ],
                            staticClass:
                              "h-5 w-5 mb-1 mr-1 stroke-current text-primary cursor-pointer",
                            attrs: { icon: "EyeIcon" },
                            on: {
                              click: function ($event) {
                                return _vm.$router.push({
                                  name: "my-subscription-detail",
                                  params: { id: tr.id },
                                })
                              },
                            },
                          }),
                          _vm.canCancel(tr)
                            ? _c("feather-icon", {
                                directives: [
                                  {
                                    name: "permission",
                                    rawName: "v-permission",
                                    value: "my_subscriptions.cancel",
                                    expression: "'my_subscriptions.cancel'",
                                  },
                                ],
                                staticClass:
                                  "h-5 w-5 mb-1 mr-1 stroke-current text-danger",
                                attrs: { icon: "XCircleIcon" },
                                on: {
                                  click: function ($event) {
                                    return _vm.openCancelModal(tr)
                                  },
                                },
                              })
                            : _vm._e(),
                        ],
                        1
                      ),
                    ]),
                  ],
                  1
                )
              })
            },
          },
        ]),
      }),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }